<template>
  <v-snackbar v-model="show" :color="color" elevation="24" bottom centered timeout="3000"> {{ message }} </v-snackbar>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  data () {
    return {
      show: false,
      message: '',
      color: ''
    }
  },

  created () {
    this.$store.subscribe((mutation) => {
      if (mutation.type === UI_SNACKBAR) {
        this.message = this.$store.getters.getSnackBar.text
        this.color = this.$store.getters.getSnackBar.color
        this.show = true
      }
    })
  }
}
</script>
